import { render, staticRenderFns } from "./BulletinBoardAdminDialog.vue?vue&type=template&id=6289293c&scoped=true&"
import script from "./BulletinBoardAdminDialog.vue?vue&type=script&lang=ts&"
export * from "./BulletinBoardAdminDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BulletinBoardAdminDialog.vue?vue&type=style&index=0&id=6289293c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6289293c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
